import React from 'react';

interface Props {
  color?: string,
  style?: object,
}

const InformationCircleSVG: React.FC<Props> = ({
  color,
}) => {
  return (
    <span className="d-flex svg-wrapper info-circle">
      <svg height="100px" width="100px" fill={color} version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="m600 216c-101.84 0-199.52 40.457-271.53 112.47-72.016 72.012-112.47 169.68-112.47 271.53s40.457 199.52 112.47 271.53c72.012 72.016 169.68 112.47 271.53 112.47s199.52-40.457 271.53-112.47c72.016-72.012 112.47-169.68 112.47-271.53 0-67.406-17.742-133.62-51.445-192-33.703-58.375-82.18-106.85-140.55-140.55-58.375-33.703-124.59-51.445-192-51.445zm0 672c-76.383 0-149.64-30.344-203.65-84.352-54.008-54.012-84.352-127.27-84.352-203.65s30.344-149.64 84.352-203.65c54.012-54.008 127.27-84.352 203.65-84.352s149.64 30.344 203.65 84.352c54.008 54.012 84.352 127.27 84.352 203.65s-30.344 149.64-84.352 203.65c-54.012 54.008-127.27 84.352-203.65 84.352z" />
          <path d="m600 588c-12.73 0-24.938 5.0586-33.941 14.059-9 9.0039-14.059 21.211-14.059 33.941v108c0 17.148 9.1484 32.996 24 41.57 14.852 8.5742 33.148 8.5742 48 0 14.852-8.5742 24-24.422 24-41.57v-108c0-12.73-5.0586-24.938-14.059-33.941-9.0039-9-21.211-14.059-33.941-14.059z" />
          <path d="m648 468c0 26.508-21.492 48-48 48s-48-21.492-48-48 21.492-48 48-48 48 21.492 48 48" />
        </g>
      </svg>
    </span>
  );
};

InformationCircleSVG.defaultProps = {
  color: '#212529',
};

export default InformationCircleSVG;
